<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap11">The Tale of Small Sarg</h1>
<blockquote>
<p class="noind" style="margin-top:20px;">And if, tomorrow all the history on which it is based is found to be defective, the clay tablets wrongly interpreted, or the whole formed out of a mistaken identification of several periods and places, our reading of it will not be affected in the slightest, for the Stranger, the City, the sights, smells and sounds, formed by the poet out of history and human activity, are real now at another level of being.</p>
</blockquote>
<p class="right">—<span class="small">NOEL STOCK</span>, <i>Reading the Cantos</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 17-chap11.vue?4e4e9de6